<template>
  <div>
    <div id="chart-wrapper">
    {{title}}
    <canvas id="myChart"></canvas>
    </div>
  </div>
</template>

<script>

import Chart from 'chart.js';

export default {
    mounted() { 
        this.generateChart()
    },
    watch:{
        chartType(){
            this.generateChart()
        },
        graphData(){
            this.generateChart()
        }
    },
    props:{
        chartType:{
            default:'bar'
        },
         title:{
            default:'Chartjs'
        },
         horizontalLabels:{
            type: Array,
            default: () => new Array
        },
        graphLabel:{
            default:'Label'
        },
        graphData:{
             type: Array,
            default: () => new Array
        }
    },
    methods: {
        generateChart() {
            const chartCanvas = document.getElementById('myChart');

            new Chart(chartCanvas, {
                type: this.chartType,
                data: {
                    labels: this.horizontalLabels,
                    datasets: [{
                        label:  this.graphLabel,
                        data: this.graphData,
                        borderWidth: 2,
                         borderColor: '#36A2EB',
                        backgroundColor: ['#9BD0F5',"#311B92",
      "#FF9800",
      "#37474F",
      "#2196F3",
      "#9C27B0",
      "#880E4F",
      "#F44336",
      "#FFAB00",
      "#E65100",
      "#827717",
      "#3E2723",
      "#000000",
      "purple"],
                    }]
                },
                options: {
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                    responsive: true,
maintainAspectRatio: false
                }
            })
        }
    }

}
</script>

<style>
#chart-wrapper {
    display: inline-block;
    position: relative;
   height:600px;
    width: 100%;
  }
</style>